const { omit, omitBy, isUndefined } = require('lodash');
const { STYLE_POSITION_ATTRIBUTES } = require('../getRootPosition/constants');
const getRootPosition = require('../getRootPosition');
const getRootTransform = require('../getRootTransform');

/**
 * Merges style attributes into svg attributes.
 * @param {Object} style The layer style
 * @param {Boolean} keepOriginalStyle Whether to keep root's original style or not
 * @returns {Object}
 */
const mergeStyleToAttributes = ({ style = {} }, keepOriginalStyle = false) => {
    const positionAttributes = getRootPosition({ style });
    const rootTransform = getRootTransform(style, positionAttributes);

    const { top, left, height, width } = positionAttributes;

    return omitBy({
        height,
        width,
        x: left,
        y: top,
        ...(rootTransform && { transform: rootTransform }),
        style: keepOriginalStyle ? style : omit(style, [...STYLE_POSITION_ATTRIBUTES, 'transform'])
    }, isUndefined);
};

module.exports = mergeStyleToAttributes;
